<script setup lang="ts">
import { computed } from 'vue'

import { useSpeckleAuthStore } from '@haskoning/vue-speckle'

import { SPECKLE, useDrawerStore } from '@/stores/drawer'

import SpeckleExportForm from '@/components/speckle/SpeckleExportForm.vue'
import SpeckleLoginRequired from '@/components/speckle/SpeckleLoginRequired.vue'

const drawerStore = useDrawerStore()
const speckleAuthStore = useSpeckleAuthStore()

const isSpeckleConnected = computed(() => speckleAuthStore.isAuthenticated)

const drawerModel = computed({
  get: () => drawerStore.speckleDrawerState,
  set: () => {
    toggleDrawer()
  }
})

const toggleDrawer = () => {
  drawerStore.toggleCalculationDrawer(SPECKLE)
}
</script>

<template>
  <v-navigation-drawer
    v-model="drawerModel"
    scrim="rgba(0,0,0,0)"
    temporary
    elevation="2"
    width="500"
  >
    <v-list class="py-0">
      <v-list-item @click.stop="toggleDrawer">
        <template #title>
          <v-card-title class="pl-0">
            <v-icon size="large" icon="custom:speckleLogoIcon"></v-icon>
            Speckle
          </v-card-title>
        </template>
        <template #append>
          <v-btn
            variant="text"
            :icon="!drawerModel ? 'mdi-chevron-right' : 'mdi-chevron-left'"
            @click.stop="toggleDrawer"
          ></v-btn>
        </template>
      </v-list-item>

      <SpeckleExportForm v-if="isSpeckleConnected" />
      <SpeckleLoginRequired v-else class="mx-4 my-2" />
    </v-list>
  </v-navigation-drawer>
</template>
